import { FC } from 'react';
import { MenuItemIcon } from '../../../components';
import { Settings, SettingsOutlined } from '@mui/icons-material';

export const IconSettingsSidebar: FC<MenuItemIcon> = ({ active }) =>
  active ? <Settings color="primary" /> : <SettingsOutlined color="action" />;
